<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2022-10-24 16:18:02
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-11-03 10:18:41
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\Organization\departmentHomePage\components\doctorList.vue
-->
<!-- 科室配置医生列表 -->
<template>
    <div class='doctor-list' v-if="centerDialogVisible">
        <el-dialog title="医生列表" top="5vh" :visible.sync="centerDialogVisible" width="40%" center
            @close="emitCloseDialog()">
            <div class="list-content" v-loading="loading">
                <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
                    <div class="doctor-label">
                        <div :class="activeIndex == index ? 'label-item' : 'label-item-active'"
                            v-for="(item,index) in diseaseTypeProps" :key="index" @click="activeLabel(item,index)">{{
                            item.diseaseTypeName }}</div>
                    </div>
                    <div class="table-content">
                        <el-table id="tableInfo" :data="tableData" style="width: 98%">
                            <el-table-column prop="doctorTeamName" label="医生团队名称" align="center"></el-table-column>
                            <el-table-column prop="doctorName" label="领衔医生" align="center"></el-table-column>
                            <el-table-column label="操作" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="mini" style="font-size:10px"
                                        @click.stop="setStatus(scope.row,1)"
                                        :disabled="scope.$index == 0 && searchForm.current == 1">上移
                                    </el-button>
                                    <el-button type="text" size="mini" :disabled="scope.row.disabled ? true : false"
                                        style="font-size:10px" @click.stop="setStatus(scope.row,2)">下移</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination style="text-align:right;margin-right:30px;margin-top:30px" background
                            @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page.sync="searchForm.current" :page-size="searchForm.size"
                            layout="total, sizes, prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </div>
                </el-scrollbar>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { doctorTeamPage, moveUp, moveDown } from '../api/index'
export default {
    props: {
        centerDialogVisible: {
            type: Boolean
        },
        diseaseTypeProps: {
            type: Array,
            default: () => {
                return [];
            }
        },
        diseaseId: {
            type: String
        }
    },
    data() {
        //这⾥存放数据
        return {
            tableData: [],
            searchForm: {
                current: 1,
                size: 10,
            },
            total: 0,
            label: [],
            activeIndex: 0,
            loading: true,
            downIndex: null,
        };
    },
    //监听属性类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //⽅法集合
    methods: {
        //点击病种出现医生列表
        activeLabel(item, index) {
            this.activeIndex = index
            this.searchForm.current = 1;
            this.searchForm.size = 10;
            this.getData()
        },
        getData() {
            this.loading = true;
            if (this.diseaseTypeProps.length == 0) {
                this.loading = false
                return false;
            }
            let obj = {
                openDepartmentId: this.diseaseId,
                diseaseTypeId: this.diseaseTypeProps[this.activeIndex].diseaseTypeId,
                size: this.searchForm.size,
                current: this.searchForm.current,
            }
            doctorTeamPage({ ...obj }).then(res => {
                this.tableData = res.data.records;
                this.total = res.data.total;
                if (this.total > 0) {
                    this.downIndex = Math.ceil(this.total / this.searchForm.size);
                    console.log('索引', this.downIndex)
                    if (this.searchForm.current == this.downIndex) {
                        this.tableData[this.tableData.length - 1].disabled = true;
                        console.log('表格数据', this.tableData)
                    }
                }
                this.loading = false
            })
        },
        //上移下移
        setStatus(row, type) {
            this.loading = true
            if (type == 1) {
                moveUp(row.id).then(res => {
                    if (res.code == 0) {
                        this.getData();
                        this.$message.success('成功');
                    }
                }).catch(err => {
                    this.loading = false
                })
            } else {
                moveDown(row.id).then(res => {
                    if (res.code == 0) {
                        this.getData();
                        this.$message.success('成功');
                    }
                }).catch(err => {
                    this.loading = false
                })
            }
        },
        //关闭弹窗
        emitCloseDialog() {
            this.$emit("update:centerDialogVisible", false);
        },
        //分页 
        handleSizeChange(e) {
            this.searchForm.size = e
            this.getData()
        },
        handleCurrentChange(e) {
            this.searchForm.current = e
            this.getData()
        },
    },
    //⽣命周期 - 创建完成（可以访问当前this实例）
    created() {
        console.log('传入数组', this.diseaseTypeProps, this.diseaseId)
        this.getData()
    },
    //⽣命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    //beforeCreate() {}, //⽣命周期 - 创建之前
    //beforeMount() {}, //⽣命周期 - 挂载之前
    //beforeUpdate() {}, //⽣命周期 - 更新之前
    //updated() {}, //⽣命周期 - 更新之后
    //beforeDestroy() {}, //⽣命周期 - 销毁之前
    //destroyed() {}, //⽣命周期 - 销毁完成
    //activated() {}, //如果页⾯有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped lang="less">
/* @import url(); 引⼊公共css类 */
.doctor-list {
    height: 100%;
    width: 100%;

    .list-content {
        height: 75vh;
        width: 100%;
        overflow: hidden;

        .doctor-label {
            display: flex;
            flex-wrap: wrap;

            .label-item {
                width: 131px;
                line-height: 35px;
                background: #1A7BFC;
                border-radius: 18px;
                padding: 0px 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                color: #fff;
                text-align: center;
                margin-right: 10px;
                margin-bottom: 15px;
                border: 1px solid #E9F2FF;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
            }

            .label-item-active {
                width: 131px;
                line-height: 35px;
                border-radius: 18px;
                padding: 0px 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                text-align: center;
                color: #1A7BFC;
                margin-right: 10px;
                margin-bottom: 15px;
                border: 1px solid #91C0FF;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
            }
        }
    }
}

/deep/.el-table__header-wrapper {
    background-color: #FAFAFA;
}

/deep/.el-table th>.cell {
    color: #333;
    font-weight: bold;
}

/deep/.el-table th {
    background: #FAFAFA;
}

/deep/.el-scrollbar__wrap {
    overflow-x: hidden;
}
</style>